import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTourGuides_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">PRIDRUŽI SE I TI!</div>
                  <h2 className="heading font-size-28 line-height-39">
                    CITY<b>X</b> VODIČI
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="sub-heading margin-top-33 line-height-24">
                    CITYX TOUR &#38; PASS aplikacija zamišljena je na način da
                    svaki turist koji skine app ima mogućnost angažiranja
                    turističkog vodiča, kao i rezervaciju ture ovisno o
                    trenutnoj lokaciji. Korištenje aplikacije je besplatno i za
                    turiste i vodiče što vodičima osigurava jedan novi kanal
                    promocije prema ciljanom klijentu, a turistima rezervaciju i
                    plaćanje uz pomoć nekoliko klikova.
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage:
                  "url(../assets/img/apps/cityx-tour-pass-tourist-guides.jpg",
                backgroundPosition: "left center",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              KAKO FUNKCIONIRA CITY<b>X</b> TOUR &#38; PASS APLIKACIJA?
            </h5>
            <p>
              Svaki turistički vodič koji zadovolji zadane kriterije (niže
              navedeni), dobiva svoj korisnički račun unutar aplikacije. U njemu
              postavlja ture, kao i datume i sate kada je dostupan za vođenje.
              Cijenu ture određuje vodič, kao i minimalan i maksimalan broj
              gostiju po turi. Prilikom rezervacije ture od strane turista,
              vodič u realnom vremenu dobiva informaciju koja je tura zatražena,
              na kojem jeziku i za koliko osoba. Hoće li ju prihvatiti ili ne,
              odluka je isključivo na vodiču! U aplikaciji vodič navodi i
              polazišnu točku ture. Ukoliko dođe do kašnjenja gosta, nema
              problema. Naime, vodiču je omogućena komunikacija s klijentima
              putem chata kako bi doznao razlog kašnjenja i što prije nastavio
              turu. Turisti, naravno, imaju mogućnost na kraju ocijeniti vodiča,
              baš kao i kvalitetu ture/tura.
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
                <h5 className="title">
                  KRITERIJI KOJE MORA ZADOVOLJITI TURISTIČKI VODIČ:
                </h5>
                <p>
                  Kako bi vodič bio potpuno besplatno uključen u CityX mrežu
                  hrvatskih vodiča, neophodno je:
                </p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={8}
                  data-mobile={8}
                  data-smobile={8}
                />
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Da uslugu pruža kao pravna osoba (npr. obrt)
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Na mail pošalje popis autorskih tura, kao i njihov opis
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">Formira cijene tura/po gostu</span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Navede maksimalni i minimalni broj gostiju na turi
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Redovito ažurira podatke i postavlja termine tura
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Prati rezervacije/aktualnosti unutar aplikacije
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={0}
                data-mobile={0}
                data-smobile={35}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 0 0 11px"
                data-mobilemargin="0 0 0 0"
              >
                <div className="inner pd35 bg-ffc">
                  <h5 className="title text-white line-height-24 padding-left-7">
                    PREUZMITE PREZENTACIJSKE MATERIJALE ZA CITYX TOUR&#38;PASS
                  </h5>
                  <br />
                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={16}
                    data-mobile={16}
                    data-smobile={16}
                  />
                  <div className="button-wrap has-icon icon-right size-14">
                    <a
                      href="/assets/pdf/CityX Tour HR.pdf"
                      className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26"
                      download
                    >
                      <span>
                        Turistički vodiči .PDF{" "}
                        <span className="icon">
                          <i className="fa fa-file-pdf-o" />
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              PONUDI USLUGE VOĐENIH TURA PREKO CITYX TOUR &#38; PASS APLIKACIJE
              JOŠ DANAS!
            </h5>
            <p>
              Javite nam se telefonski ili pošaljite zahtjev za kontaktom preko
              forme.
            </p>
            <div className="flat-content-wrap style-2 clearfix">
              <p style={{ padding: "0px" }}>
                <iframe
                  src="https://forms.monday.com/forms/embed/3699c1114b3775c5b4370be9337f7ad4?r=use1"
                  width={"100%"}
                  style={{
                    width: "200%",
                    height: "1000px",
                  }}
                ></iframe>
              </p>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXTourGuides_SiteContent;
